/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetVariantDetailQueryResponse,
  GetVariantDetailPathParams,
  GetVariantDetail404,
} from '../types/GetVariantDetail'

function getGetVariantDetailUrl({
  id,
}: {
  id: GetVariantDetailPathParams['id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/variants/${id}/` as const,
  }
  return res
}

/**
 * @description Get variant detail.
 * GET /variants/{pk}/
 * Args:
 * request: The request object
 * pk: Variant ID
 * Returns:
 * Response with variant data or error
 * @summary Get variant detail
 * {@link /api/v1/products/catalog/variants/:id/}
 */
export async function getVariantDetail(
  { id }: { id: GetVariantDetailPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetVariantDetailQueryResponse,
    ResponseErrorConfig<GetVariantDetail404>,
    unknown
  >({
    method: 'GET',
    url: getGetVariantDetailUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
